import React from "react";
import "./slick.scss";
import styles from "./Carousel.module.scss";

import Slider from "react-slick";

function SampleNextArrow(props) {
	const { className, style, onClick } = props;
	return <div className={className} onClick={onClick} />;
}

function SamplePrevArrow(props) {
	const { className, style, onClick } = props;
	return <div className={className} onClick={onClick} />;
}

const renderTestimonials = (array = []) => {
	return array.map((item, i) => {
		return (
			<div key={"testimonial-" + i }>
				<blockquote className="blockquote text-center py-2">
					<p className={styles.quote}>
						{item.node.testimony.testimony}
					</p>
					<footer className="blockquote-footer">
						{item.node.author},{" "}
						<cite title="Source Title">{item.node.organisation.name}</cite>
					</footer>
				</blockquote>
			</div>
		);
	});
};

class Carousel extends React.Component {
	render() {
		var settings = {
			dots: true,
			infinite: true,
			speed: 500,
			slidesToShow: 1,
			slidesToScroll: 1,
			nextArrow: <SampleNextArrow />,
			prevArrow: <SamplePrevArrow />
		};

		const { testimonials } = this.props;
		return (
			<Slider {...settings}>
			{renderTestimonials(testimonials)}

			</Slider>
		);
	}
}
export default Carousel;



// WEBPACK FOOTER //
// ./src/components/Carousel/index.js